module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_LogOut_16"],"path":[{"$":{"d":"M11,15H1V1H11V4H9V3H3V13H9V12h2Zm5-7L12,5V7H5V9h7v2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_LogOut_16.svg
// module id = Di+4
// module chunks = 1